import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';

const PricingPage = () => {
  const packages = [
    {
      title: 'The Essentials Pack: “Get Online Starter”',
      description: 'For startups or individuals launching their first website.',
      normalPrice: 'R2,800',
      campaignPrice: 'R1,850',
      features: [
        '1-page responsive website (Home/About).',
        'Basic SEO setup for search engine visibility.',
        'Mobile and tablet optimization.',
        'Domain and hosting setup assistance (domain/hosting fees excluded).',
        '1 round of revisions.'
      ]
    },
    {
      title: 'The Business Pack: “Professional Presence”',
      description: 'For small businesses that need a polished and professional website.',
      normalPrice: 'R5,000',
      campaignPrice: 'R3,500',
      features: [
        '3-page responsive website (Home, About, Contact).',
        'Integrated contact form and Google Maps.',
        'Social media integration (links to your platforms).',
        'Basic SEO and Google Business Profile setup.',
        '1 month of free updates.'
      ]
    },
    {
      title: 'The Shop Pack: “Start Selling Online”',
      description: 'Perfect for businesses stepping into e-commerce.',
      normalPrice: 'R8,500',
      campaignPrice: 'R5,800',
      features: [
        'E-commerce store with up to 10 products.',
        'Payment gateway integration (PayFast/Yoco).',
        'Shopping cart and order management system.',
        'Email notification setup for orders.',
        'Training session on managing your store.'
      ]
    },
    {
      title: 'The Custom Pack: “Tailored Web Solutions”',
      description: 'For businesses requiring a unique, custom-built website.',
      normalPrice: 'R10,000',
      campaignPrice: 'R7,500',
      features: [
        'Fully custom-designed website (up to 5 pages).',
        'Advanced features like booking systems, galleries, or blogs.',
        'Integration with third-party tools (e.g., Mailchimp, Calendly).',
        'Detailed SEO optimization and analytics setup.',
        '2 rounds of design revisions.'
      ]
    },
    {
      title: 'The Premium Pack: “Scale Your Business Online”',
      description: 'For businesses ready for a robust, feature-packed website.',
      normalPrice: 'R14,000',
      campaignPrice: 'R9,800',
      features: [
        'E-commerce website with up to 30 products.',
        'Advanced user account system (for customers or members).',
        'Automated email marketing integration.',
        'Comprehensive SEO setup and performance tracking.',
        '3 months of free maintenance and updates.'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12 mt-12">
          <h1 className="text-5xl font-bold text-perspective-green mb-4">
            2025 Business Kickstarter Packages
          </h1>
          <p className="text-lg text-gray-700">
            Start 2025 strong with our affordable packages available for a limited time.
          </p>
        </div>

        <div className="space-y-10">
          {packages.map((pack, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-lg shadow-lg p-6">
              <h2 className="text-2xl font-bold text-perspective-green mb-2">{pack.title}</h2>
              <p className="text-gray-700 mb-4">{pack.description}</p>
              <div className="mb-4">
                <span className="line-through text-gray-500">{pack.normalPrice}</span>
                <span className="text-lg font-bold text-perspective-sage ml-2">{pack.campaignPrice}</span>
              </div>
              <ul className="list-disc list-inside space-y-2 mb-4 text-gray-700">
                {pack.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/contact"
            className="inline-block bg-perspective-green text-white py-3 px-6 rounded-md shadow-lg font-bold text-lg hover:bg-perspective-sage hover:text-perspective-green transition-all"
          >
            Get in Touch
          </Link>
        </div>
      </div>
      <footer className="mt-12 bg-perspective-green text-white py-6">
        <div className="max-w-7xl mx-auto text-center">
          <p>&copy; 2021-2025 PerspectiveHQ. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default PricingPage;
